import { Accordion, AccordionItem } from '@nextui-org/react'
import { useState } from 'react'
import type { Selection } from '@nextui-org/react'
import IconClose from '@/components/Icon/close'
import IconOpen from '@/components/Icon/open'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

export default function HomeHelp() {
	const [selectedKeys, setSelectedKeys] = useState<Selection>(new Set(['1']))

	const { t } = useTranslation()

	return (
		<div className="relative z-10 px-2">
			<div className="tail-text-menu pl-1 text-[2.5rem] font-semibold">{t('swap.help.title')}</div>
			<Accordion selectedKeys={selectedKeys} className="tail-accordion" onSelectionChange={setSelectedKeys}>
				<AccordionItem
					indicator={({ isOpen }) => (!isOpen ? <IconOpen /> : <IconClose />)}
					key="1"
					classNames={{
						title: 'text-xl',
						indicator: '!rotate-0	',
					}}
					aria-label="Accordion 1"
					title={t('swap.help.title1')}
				>
					<div className="pl-1 text-base text-[#929292]">{t('swap.help.1')}</div>
				</AccordionItem>
				<AccordionItem
					classNames={{
						title: 'text-xl',
						indicator: '!rotate-0	',
					}}
					key="2"
					indicator={({ isOpen }) => (!isOpen ? <IconOpen /> : <IconClose />)}
					aria-label="Accordion 2"
					title={t('swap.help.title2')}
				>
					<div className="pl-1 text-base text-[#929292]">{t('swap.help.2')}</div>
				</AccordionItem>
				<AccordionItem
					key="3"
					classNames={{
						title: 'text-xl',
						indicator: '!rotate-0	',
					}}
					indicator={({ isOpen }) => (!isOpen ? <IconOpen /> : <IconClose />)}
					aria-label="Accordion 3"
					title={t('swap.help.title3')}
				>
					<div className="pl-1 text-base text-[#929292]">
						{t('swap.help.3')} <br />
						{t('swap.help.4')} <br />
						{t('swap.help.5')}
					</div>
				</AccordionItem>
			</Accordion>
			<div className="flex items-start pl-1 pt-[1.125rem]">
				<div className="tail-home-help-faq">
					<Link to="/help" className="text-base font-bold text-white">
						{t('swap.help.6')}
					</Link>
					<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path
							d="M12.25 6.99992L9.33333 4.08325M12.25 6.99992L9.33333 9.91659M12.25 6.99992H1.75"
							stroke="white"
							strokeWidth="2"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
					</svg>
				</div>
			</div>
		</div>
	)
}
